import PropTypes from 'prop-types';
import React, { useLayoutEffect, useRef } from 'react';
import cx from 'classnames';
import scrollToElement from 'scroll-to-element';
import styles from './FormError.css';

const FormError = ({
  error,
  ariaLabel,
  style,
  className,
  focus,
  focusKey,
  tabIndex: tabIndexProp,
  ...props
}) => {
  const ref = useRef(null);

  const errorDepForFocus =
    typeof error === 'string' || typeof error === 'number' ? error : '';

  useLayoutEffect(() => {
    if (!focus || !error) {
      return;
    }
    const el = ref.current;
    if (!el) {
      return;
    }
    scrollToElement(el, { align: 'middle' });
    el.focus({ preventScroll: true });
  }, [focus, focusKey, errorDepForFocus]);

  if (!error) {
    return null;
  }

  return (<div
    ref={ref}
    className={cx(styles.error, className)}
    style={style}
    role="alert"
    aria-live="assertive"
    aria-label={ariaLabel || undefined}
    {...props}
    tabIndex={focus ? -1 : tabIndexProp}
  >
    {error}
  </div>);
};

FormError.propTypes = {
  error: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
    PropTypes.object,
  ]),
  ariaLabel: PropTypes.string,
  style: PropTypes.object,
  className: PropTypes.string,
  focus: PropTypes.bool,
  focusKey: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  tabIndex: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
};

export default FormError;



// WEBPACK FOOTER //
// ./src/client/Components/Forms/FormError/FormError.js